import {
  $createLineBreakNode,
  $createParagraphNode,
  $createTabNode,
  $createTextNode,
  $getRoot,
  $isLineBreakNode,
  $isTextNode,
  type LexicalEditor,
} from "lexical";

import {
  type ParagraphRun,
  mergeRuns,
  splitRunText,
} from "./paragraph_editor_runs";

const FORMATS = ["bold", "italic", "underline"] as const;

// His paragraph's runs, as the editor's one paragraph.
export const $seed = (runs: ReadonlyArray<ParagraphRun>) => {
  const paragraph = $createParagraphNode();
  runs.forEach((run) => {
    splitRunText(run.text).forEach((part) => {
      if (part === "\n") return paragraph.append($createLineBreakNode());
      const node = part === "\t" ? $createTabNode() : $createTextNode(part);
      FORMATS.forEach((format) => {
        if (run[format]) node.toggleFormat(format);
      });
      paragraph.append(node);
    });
  });
  $getRoot().append(paragraph);
};

// The paragraph as he left it: its text in runs, tabs and line breaks
// included.
export const readRuns = (editor: LexicalEditor) =>
  editor.getEditorState().read(() =>
    mergeRuns(
      $getRoot().getAllTextNodes().length === 0
        ? []
        : $getRoot()
            .getChildren()
            .flatMap((block) =>
              "getChildren" in block && typeof block.getChildren === "function"
                ? (block.getChildren() as ReturnType<typeof $getRoot>[])
                : [],
            )
            .map((node) => ({
              text: $isLineBreakNode(node) ? "\n" : node.getTextContent(),
              bold: $isTextNode(node) && node.hasFormat("bold"),
              italic: $isTextNode(node) && node.hasFormat("italic"),
              underline: $isTextNode(node) && node.hasFormat("underline"),
            })),
    ),
  );
